export interface CustomAxiosHeaders {
  host?: string
  headers?: any
  serviceName?: string
  useNewToken?: boolean
  skipInterceptor?: boolean
}

let keys: {
  PerformanceMonitoringService?: string
} = {}

export const override: boolean = process.env.VUE_APP_DB_OVERRIDE === 'true'

if (override || process.env.NODE_ENV === 'production') {
  keys = {
    PerformanceMonitoringService: `https://${window.location.host}/_pm`,
  }
} else if (process.env.NODE_ENV === 'beta' && !override) {
  keys = {
    PerformanceMonitoringService: `https://${window.location.host}/_pm`,
  }
} else if (!override && (process.env.NODE_ENV === 'staging' || process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test')) {
  keys = {
    PerformanceMonitoringService:
      window.location.host == 'staging.gohighlevel.com'
        ? `https://staging.gohighlevel.com/_pm`
        : `https://staging.backend.leadconnectorhq.com/performance-monitoring`,
  }
  if (process.env.NODE_ENV === 'development' && !override) {
    // keys.PerformanceMonitoringService = 'https://app.gohighlevel.com/_pm'
  }
} else if (process.env.NODE_ENV === 'interop' && !override) {
  keys = {
    PerformanceMonitoringService:
      window.location.host == 'interop.gohighlevel.com'
        ? `https://interop.gohighlevel.com/_pm`
        : `https://interop.backend.leadconnectorhq.com/performance-monitoring`,
  }
}

export default keys
